import BaseApi from '../../../infraestructure/BaseApi';

export default class ApiModules extends BaseApi{
    constructor(client, endPoint) {
        super(client, endPoint)
    }
}